<template>
  <div>
    <div class="col-lg-12">
        <h4 class="text-center" >Muatnaik Gambar Kejadian</h4>
        <p
          class="text-center"
          style="font-style: italic; margin-bottom: 3%"
        >(Sekurang-kurangnya gambar lokasi kejadian, kecederaan pekerja atau orang awam, kerosakan harta benda syarikat atau awam)</p>
        <div class="row justify-content-center">
          <div class="col-lg-9" style="border: black solid; border-radius: 10px; padding-top: 1%">
            <div class="row justify-content-center">
              <div class="col-md-3 text-right">
                <image-upload @change="onImageChange" select-text="Select Image" :src="img" v-model="image"/>
              </div>
              <!-- <div class="col-md-5">
                <textarea class="keterangan" placeholder="Keterangan Gambar" v-model="imgdescription"></textarea>
              </div> -->
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload } from "src/components";

export default {
  props: ["parentData"],
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
  },
  props: ["test1"],
  data() {
    return {
      img: null,
      imgdescription: "",
      image:"",
      imagebase64: "",
      images: {
        regular: null
      },
    };
  },
  created() {
    // this.getIncidentType();
  },
  mounted() {},
  methods: {
    onImageChange(file){
        this.images.regular = file;
      console.log(this.image)
      console.log(file.name)
      this.img = file.name
      console.log(file)
      // this.imagebase64 = file
      const reader = new FileReader()

      reader.onload = (event) => {
        file = event.target.result
        // console.log(file)
              // rebuild cropperjs with the updated source
        // this.$refs.cropper.replace(event.target.result)
        file.replace(event.target.result)
        // console.log(file)
        this.imagebase64 = file.split(',')[1]
        console.log(this.imagebase64)
      }
      reader.readAsDataURL(file) 
//    data:image/png;base64,
      
    },
    validate() {
        if(this.imagebase64 == "" || this.images.regular == null){
            swal({
                title: "Data Error!",
                text: "All data must be filled in.",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
            });
        } else {
            return this.$validator.validateAll().then((res) => {
                this.$root.$emit("image", this.imagebase64);
                return res;
            });
        }
        
    },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
